import axios from 'axios';
import {API_URL} from './config.util';
import authHeader from '../service/auth-header';
import {handleError} from './notification.utils';
import {receiptOwnerPath} from './customer.context';

/**
 * Generic function to download a PDF file (invoice, receipt, etc.)
 */
async function downloadPdfFile(endpoint, filename, setDownloading) {
  try {
    if (setDownloading) setDownloading(true);

    const response = await axios.get(`${API_URL}${endpoint}`, {
      responseType: 'arraybuffer',
      headers: authHeader(),
    });

    const blob = new Blob([response.data], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'document.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    await handleError(error, 'Error downloading PDF');
  } finally {
    if (setDownloading) setDownloading(false);
  }
}

/**
 * Download Quotation PDF
 */
export function downloadQuotationPdf(quotationId, filename, templateId, setDownloading) {
  const endpoint = `/app/quotations/${quotationId}/pdf${templateId ? `?templateId=${templateId}` : ''}`;
  return downloadPdfFile(endpoint, filename, setDownloading);
}

/**
 * Download Invoice PDF
 */
export function downloadInvoicePdf(invoiceId, filename, templateId, setDownloading) {
  const endpoint = `/app/invoices/${invoiceId}/pdf${templateId ? `?templateId=${templateId}` : ''}`;
  return downloadPdfFile(endpoint, filename, setDownloading);
}

/**
 * Download Receipt PDF
 */
export function downloadReceiptPdf(mid, receiptId, filename, templateId, setDownloading) {
  // A customer contact downloads through their customer's route, which checks they are its contact.
  const path = receiptOwnerPath(mid, `/receipts/${receiptId}/pdf`);
  const endpoint = `${path}${templateId ? `?templateId=${templateId}` : ''}`;
  return downloadPdfFile(endpoint, filename, setDownloading);
}



// WEBPACK FOOTER //
// ./src/utils/invoiceUtils.js